// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>6</span>&nbsp;&nbsp;He makes Lebanon skip like a calf&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and Sirion like a young wild ox.<br> </p> </div></div>";
// Exports
module.exports = code;